// extracted by mini-css-extract-plugin
module.exports = {"containerStyle":"_1lNSc8rHP0IfvWvADJBvQq","clientContainerStyle":"_1nzbx1hOnlnmacul52_Haa"};